import Analytic from '@commons/cards/analytic'
import Grid from '@components/grid'

import { Fragment } from 'react/jsx-runtime'

import Title from '@components/title'
import Column from '@components/column'
import { useSelector } from 'react-redux'
import { RootState } from '@store'
import { Dashboard } from '@apis/index'
import { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

// {
//   "data": {
//       "totalRevenue": 11300,
//       "totalDiscount": 850,
//       "totalWithdrawRequest": 1900,
//       "totalWithdrawRelease": 300,
//       "totalRoutes": 0,
//       "totalVehicles": 0,
//       "totalCashRevenue": 0
//   },
//   "message": "SUCCESS"
// }

const DashboardCard = ({ cardConfig = [] }: { cardConfig?: any }) => {
  const navigate = useNavigate()
  const { pathname } = useLocation()
  const { data: dashboard, loading } = useSelector(
    (state: RootState) => state.dashboard,
  )

  const fetchDashboard = async () => {
    try {
      await Dashboard.list({ state: 'dashboard' })
    } catch (error) {}
  }
  useEffect(() => {
    fetchDashboard().then(() => {})
  }, [])
  return (
    <Fragment>
      <Column>
        {pathname === '/admin/dashboard' && (
          <Title textone="Welcome back," texttwo="Admin" />
        )}

        <Grid>
          {cardConfig?.map((card, i) => (
            <Analytic
              loading={loading}
              key={i}
              title={card.title}
              icon={card.icon}
              value={dashboard?.[card.key] ?? 0}
              percentChange="10"
              isUp={card.isUp}
              onClick={() => {
                navigate(card.link)
              }}
            />
          ))}
        </Grid>
      </Column>
    </Fragment>
  )
}
export default DashboardCard
